import React, {useEffect, useState} from 'react';

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

type ErrorModalProps = {
    anchorOrigin: { vertical?: "top" | "bottom", horizontal?: "right" | "left" | "center" }
    open: boolean
    onClose: () => void
    autoHideDuration: number
    status: "success" | "error" | undefined
    message: string
}

const RequestResultSnackbar: React.FC<ErrorModalProps> = ({open = false, anchorOrigin: { vertical = "top", horizontal= "right"}, onClose, autoHideDuration = 4000, status, message =""}) => {
    const [headerHeight, setHeaderHeight] = useState<number>(0);

    useEffect(() => {
        const header = document.querySelector("header")
        if(header)setHeaderHeight(header.clientHeight);
    }, [])

    return (
        <Snackbar
            anchorOrigin={{ vertical: vertical, horizontal: horizontal }}
            open={open}
            onClose={onClose}
            autoHideDuration={autoHideDuration}
            sx={{"&.MuiSnackbar-anchorOriginTopRight": { top: headerHeight + 20}}}
        >
            <Alert severity={status} onClose={onClose}>{message}</Alert>
        </Snackbar>
    );
};

export default RequestResultSnackbar;